import Model from './private/Model'

export default class GeneralModel extends Model{
}